import styles from './Pagination.module.scss';
import cn from 'classnames';
import { usePagination, DOTS } from '../../hooks/usePagination';
import {DetailedHTMLProps, HTMLAttributes} from "react";

export interface PaginationProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    onPageChange: (page: number) => void,
    totalCount: number,
    siblingCount: number,
    currentPage: number,
    pageSize: number,
}

const Pagination = (props: PaginationProps) => {
    const {
        onPageChange,
        className,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
    } = props;

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize,
    });

    if (currentPage === 0 || (paginationRange && paginationRange.length < 2)) {
        return null;
    }

    const onNext = () => {
        if(currentPage < Math.ceil(totalCount/pageSize))
            onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    const lastPage = paginationRange? paginationRange[paginationRange.length - 1] : 0;

    return (
        <div className={cn( styles.pagination, className)}>
            <ul className={styles.paginationList}>
                {paginationRange?.map((pageNumber, i) => {

                    if (pageNumber === DOTS) {
                        return (
                            <li key={i} className={styles.paginationSeparator}>
                                ...
                            </li>
                        );
                    }

                    return (
                        <li key={i}
                            className={cn(styles.paginationItem, {
                                [styles.paginationCurrent]: pageNumber === currentPage
                            })}
                            onClick={() => onPageChange(Number(pageNumber))}
                        >
                            {pageNumber}
                        </li>
                    );
                })}
            </ul>
            {
            currentPage != Math.ceil(totalCount/pageSize) &&
              <>
                <button className={styles.paginationBtn} onClick={onNext}>
                    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.5 11L6.5 6L1.5 1" stroke="black" stroke-width="2"/>
                    </svg>
                </button>
                  {Math.ceil(totalCount/pageSize) > 6 && <button className={styles.paginationBtn}
                           onClick={() => onPageChange(Math.ceil(totalCount / pageSize))}>
                      <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.5 15L12.5 10L7.5 5" stroke="black" stroke-width="2"/>
                          <path d="M15.5 15L20.5 10L15.5 5" stroke="black" stroke-width="2"/>
                      </svg>
                  </button>}
            </>}
        </div>
    );
};

export default Pagination;
